<template >
  <div class="deviceBind">
   <el-card class="box-card">
    <div slot="header" class="clearfix">
      <div style="float:left">

      </div>
      <span style="line-height: 36px;">用户例外流程</span>
      <el-button style="float: right;margin-left:10px;" type="danger" @click="popRemovePic">删除</el-button>
    </div>
    <div class="bindTable">
      <el-table
      ref="deviceSelect"
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      height="520"
      style="width: 100%"
      @selection-change="deviceSelectionChange">
      <el-table-column
        type="selection"
        width="40">
      </el-table-column>
      <el-table-column
        prop="userAccount"
        header-align="center"
        min-width="95"
        label="用户账号">
      </el-table-column>

      <el-table-column
        prop="nickName"
        header-align="center"
        min-width="95"
        label="用户昵称">
      </el-table-column>

      <el-table-column
        prop="charge"
        header-align="center"
        min-width="250"
        label="价格">
      </el-table-column>

      <el-table-column

        header-align="center"
        min-width="120"
        label="流程">
        <template scope="scope">
          <el-popover
            ref="popoverPayStatus1"
            placement="top-start"
            width="200"
            trigger="hover">
            <h4 style="text-align: center;">取货流程{{scope.row.payStatus}}</h4>
            <p>{{payStatusDes(scope.row.payStatus)}}</p>
          </el-popover>
          <span style="padding: 5px 10px;" v-popover:popoverPayStatus1>{{scope.row.payStatus}}</span>
          <i class="el-icon-edit"
          @click="popEditP(scope.row.num,scope.row.payStatus,scope.row.payPoints,scope.row.payCharge, scope.row.extendInfo, scope.row.bGetUserInfo,scope.row.userId)"></i>
        </template>
      </el-table-column>


    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>


  <pu-edit-pop
    :add-show="myEditPopShow"
    :edit-dvce-code="deviceCode"
    :edit-status="eStatus"
    :edit-points="ePoints"
    :edit-price="ePrice"
    :edit-extend="extendInfo"
    :edit-get-userinfo="bGetUserInfo"
    :edit-user-id="eUserId"
    @closeEditPoint="closeEditP"></pu-edit-pop>

  </div>
</template>
<script>
    import puAllotPopRight from '@/page/deviceMgr/allotPopRight'
    import puSeePopRight from '@/page/deviceMgr/seePopRight'
    import puEditPop from '@/page/deviceMgr/editPoint'


    import $axios from '../../https/config'
    import {isNull,getAuthority} from '../../js/tool'
    import store from '../../vuex/store'

    export default {
      data () {
        return {
          deviceData: [],
          value4: 1,
          myEditPopShow: false,
          myEditPopShowParam: false,
          myEditPriceShow: false,
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          userType: this.$store.state.userType,
          table_loading: false,
          spaceTypeList: '',
          allotPopRightOk: false,
          multipleSelection: '',
          deviceSelect: [],
          allotType: '',
          seePopRightOk: false,
          deviceCode: '',
          eStatus: '',
          ePoints: '',
          ePrice: '',
          eUserId:'',
          seeType: '',
          allotShow: false,
          seeShow: false,
          searchValue: '',
          searchSelect: '0',
          deviceId: '',
          uuid: '',
          laneInfoStr:'',
          accessToken:'',
          extendInfo:{},
          bGetUserInfo: true

        }
      },
      created: function () {
        this.pageNo = 1
        this.queryFlowList(this.pageNo, this.pageSize)
        this.accessToken = sessionStorage.getItem('lbz_accessToken')
      },
      methods: {
        getAuthorityNoFlow () {
          return getAuthority("noFlow")
        },
        handleSizeChange (val) {
          this.pageSize = val
          if (isNull(this.searchValue)) {
            this.queryFlowList(this.pageNo, this.pageSize)
          }
        },
        handleCurrentChange (val) {
          this.pageNo = val
          if (isNull(this.searchValue)) {
            this.queryFlowList(this.pageNo, this.pageSize)
          }
        },
        deviceSelectionChange (val) {
          this.deviceSelect = val
          this.multipleSelection = ''
          this.deviceId = ''
          for (var i = 0; i < val.length; i++) {
            this.multipleSelection += (val[i].userId + '|')
            //this.deviceId += (val[i].id + '|')
          }
        },
        queryFlowList (tPageNo, tPageSize) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
          }
          this.table_loading = true
          this.deviceData = []
          $axios.get('/userChargeConfig/getUserConfigListByUser', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var extendInfoItem = {}

                  if (!isNull(itemData.extendInfo)&&itemData.extendInfo.indexOf('{')>-1){
                    extendInfoItem = JSON.parse(itemData.extendInfo)
                  }

                  var item = {
                    userAccount:itemData.userAccount,
                    nickName:itemData.nickName,
                    charge:itemData.charge/100,
                    payStatus:itemData.status,
                    num: '',

                    userId: itemData.userId,
                    payPoints: itemData.point,
                    payCharge: itemData.charge,
                    extendInfo:extendInfoItem,
                    bGetUserInfo:itemData.bGetUserInfo
                  }

                  //console.log("item="+JSON.stringify(item))
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {
          })
        },

        popEditP (code, status, po, pr, extendInfo, bGetUserInfo,userId) {
          this.deviceCode = code
          this.eStatus = status
          this.ePoints = po
          this.ePrice = pr
          this.myEditPopShow = true
          this.extendInfo = extendInfo
          this.bGetUserInfo = bGetUserInfo
          this.eUserId = userId
          console.log("eUserId="+this.eUserId)
        },

        closeEditP () {
          this.myEditPopShow = false
          if (isNull(this.searchValue)) {
            this.queryFlowList(this.pageNo, this.pageSize, '')
          } else {
            //this.queryDeviceListByKey(this.searchSelect, this.searchValue, this.pageNo, this.pageSize)
          }
        },

        seeNext (mSeeType, mDeviceCoe, uuid) {
          this.uuid = uuid
          this.deviceCode = mDeviceCoe
          this.seeType = mSeeType
          this.seePopRightOk = true
          this.seeShow = true
        },
        popRemovePic () {
          var that = this
          if (that.multipleSelection.length === 0) {
            that.$message({
              message: '请选择要删除的等级',
              type: 'info'
            })
            return false
          }
          var params = {
            userId: that.multipleSelection
          }
          that.$confirm('您已选择用户的ID：' + that.multipleSelection, '是否删除选中的等级', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            $axios.get('/userChargeConfig/delUserConfig', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                that.queryFlowList()
                that.$message({
                  type: 'success',
                  message: '删除成功!'
                })
              } else {
              }
            }, function () {
              that.$message({
                type: 'error',
                message: '删除失败!'
              })
            })
          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        },
        payStatusDes (num) {
          var payStatusDesValue = [{
            key: 0,
            value: '文章标准'
          }, {
            key: 1,
            value: '文章纯积分(已停止使用)'
          }, {
            key: 2,
            value: '支付页购买(已停止使用)'
          }, {
            key: 3,
            value: '承德888'
          }, {
            key: 4,
            value: '支付无页面(已停止使用)'
          }, {
            key: 5,
            value: '长按标准(已停止使用)'
          }, {
            key: 6,
            value: '纯支付--支持支付宝和微信'
          }, {
            key: 7,
            value: '长按每天一包(已停止使用)'
          }, {
            key: 8,
            value: '每天长按一包'
          }, {
            key: 9,
            value: '每天多包,长按,可以左右滑动(停止使用)'
          }, {
            key: 10,
            value: '每天多包,长按,可以左右滑动,有再来一次按钮'
          }, {
            key: 13,
            value: '每天免费一包，再次收费'
          }, {
            key: 1001,
            value: '嘉兴的流程(定制的流程)'
          }]
          var returnData
          if (num === '无') {
            returnData = '未知流程'
          } else {
            returnData = '未知流程'
            for (var i = 0; i < payStatusDesValue.length; i++) {
              if (num === payStatusDesValue[i].key) {
                returnData = payStatusDesValue[i].value
              }
            }
          }
          return returnData
        }

      },
      components: {
        'pu-edit-pop': puEditPop
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
    .deviceBind {
        .el-select .el-input {
          width: 110px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/globalConfig/userException.vue